export const CategorySchemas = {
    categoryListItemList: "categoryListItemList",
    categoryListBreadCrumbList: "categoryListBreadCrumbList",
    categoryDetailOrganization: "categoryDetailOrganization",
};